import CompetitionPageV2 from 'marketing/components/Competitions'

function UKCompetitionPage() {
  return (
    <CompetitionPageV2
      slug="ukCompetition"
    />
  )
}

export default UKCompetitionPage
